import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

const StatusList = ({ children }) => (
  <div style={{ marginLeft: '34px' }}>
    <ReactTable
      className="c-table-new c-no-hover"
      TheadComponent={() => null}
      data={[children]}
      minRows={0}
      showPagination={false}
      resizable={false}
      columns={[{
        id: 'placeholder',
        accessor: item => item,
        className: 'u-text-center',
      }]}
    />
  </div>
);

StatusList.propTypes = {
  children: PropTypes.string.isRequired,
};

export default StatusList;
